import { FC, useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { appActions } from 'store/app/appSlice';
import { selectQuiz } from 'store/quiz/quizzesSelectors';
import { selectQuizFormMenuItem } from 'store/app/appSelectors';
import IQuiz from 'models/Quiz';
import QuizTypes from 'types/QuizTypes';
// Components
import MenuItem from './MenuItem';

interface IMenuItem {
  value: string;
  label: string;
  icon: string;
  quizType: QuizTypes[];
  hidden?: boolean;
}

const QuizMenu:FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const quizFormMenuItem = useAppSelector(selectQuizFormMenuItem);
  const quiz:IQuiz | null = useAppSelector(selectQuiz);

  const [ menuItemErrors, setMenuItemErrors ] = useState<string[]>([]);

  const { watch, formState:{ errors } } = useFormContext();

  const registrationPageWatcher = watch('registrationPage');

  const menuItems:IMenuItem[] = useMemo(() => {
    if ( !quiz ) return [];

    return [
      { value: 'main', label: t('labels.main'), icon: 'list', quizType: [QuizTypes.Scoring, QuizTypes.Personality, QuizTypes.Prediction, QuizTypes.Poll, QuizTypes.Survey, QuizTypes.RankingPoll, QuizTypes.TeamSelector, QuizTypes.BeatTheExpert, QuizTypes.Streak] },
      { value: 'prizes', label: t('labels.prizes'), icon: 'cup', quizType: [QuizTypes.Scoring, QuizTypes.Prediction, QuizTypes.Poll, QuizTypes.RankingPoll, QuizTypes.BeatTheExpert, QuizTypes.Streak, QuizTypes.TeamSelector, QuizTypes.Survey] },
      { value: 'buckets', label: t('labels.buckets'), icon: 'delete', quizType: [QuizTypes.Personality] },
      { value: 'theme', label: t('labels.theme'), icon: 'theme', quizType: [QuizTypes.Scoring, QuizTypes.Personality, QuizTypes.Prediction, QuizTypes.Poll, QuizTypes.Survey, QuizTypes.RankingPoll, QuizTypes.TeamSelector, QuizTypes.BeatTheExpert, QuizTypes.Streak] },
      { value: 'images', label: t('labels.images'), icon: 'images', quizType: [QuizTypes.Scoring, QuizTypes.Personality, QuizTypes.Prediction, QuizTypes.Poll, QuizTypes.Survey, QuizTypes.RankingPoll, QuizTypes.TeamSelector, QuizTypes.BeatTheExpert, QuizTypes.Streak] },
      { value: 'questionsSettings', label: t('labels.questionsSettings'), icon: 'settings', quizType: [QuizTypes.Scoring, QuizTypes.Prediction, QuizTypes.Poll, QuizTypes.RankingPoll, QuizTypes.TeamSelector, QuizTypes.BeatTheExpert, QuizTypes.Streak, QuizTypes.Personality, QuizTypes.Survey] },
    ]
    // eslint-disable-next-line
  }, [t, registrationPageWatcher]);

  useEffect(() => {
    dispatch(appActions.setQuizFormMenuItem('main'));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log(errors);
    
    if ( Object.keys(errors) ){
      const nextErrors = [];
      if ( errors.namespace || errors.owner || errors.quizName || errors.startsDate || errors.endsDate || errors.registrationCaption ){
        nextErrors.push('main');
      }
      if ( errors.buckets ){
        nextErrors.push('buckets');
      }
      if ( errors.prizes || errors.spotPrizes ){
        nextErrors.push('prizes');
      }
      if ( errors.logoImage ){
        nextErrors.push('images');
      }
      setMenuItemErrors(nextErrors);
    }
    // eslint-disable-next-line
  }, [Object.keys(errors).length]);

  return (
    <div className="flex flex-col flex-grow bg-content rounded-xl">
      {menuItems.map(menuItem => {
        if (menuItem.hidden) return null;
        if (quiz && !menuItem.quizType.includes(quiz.type)) return null;
        return (
          <MenuItem
            key={`menu-item-${menuItem.value}`}
            menuItem={menuItem}
            active={quizFormMenuItem === menuItem.value}
            error={menuItemErrors.includes(menuItem.value)}
            forceExpande={true}
          />
        )
      })}
    </div>
  )
}

export default QuizMenu;
